import { render, staticRenderFns } from "./MonthlyIncomeDisbursement.vue?vue&type=template&id=0c5ab75e&"
import script from "./MonthlyIncomeDisbursement.vue?vue&type=script&lang=ts&"
export * from "./MonthlyIncomeDisbursement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports